import Swal from 'sweetalert2/dist/sweetalert2.js'


export default {
    install: (app, options) => {

        app.config.globalProperties.$foneturkToast = (text, title="ALERT", didOpen) => {
            let swalToastConfig = {
                customClass: {
                    container:      'foneturk-toast-container',
                    popup:          'foneturk-toast-popup',
                    htmlContainer:  'foneturk-toast-html-container',
                },
                showClass: {
                    popup: 'swal2-toast-show',
                },
                hideClass: {
                    popup: 'swal2-toast-hide',
                },
                toast: true,
                showConfirmButton: false,
                timer: 1500,
                didOpen: function(elPopup){
                    console.log(elPopup);
                    elPopup.addEventListener('click', () => {
                        Swal.close();
                    });
                },
                html: `
                    <div class="foneturk-toast">
                        <div class="foneturk-toast__header">
                            <span class="foneturk-toast-header__icon"></span>
                            <span class="foneturk-toast-header__text">${title}</span>
                        </div>
                        <span class="foneturk-toast__text">${text}</span>
                    </div>
                `,
            };

            if(typeof didOpen == 'function'){
                swalToastConfig.didOpen = didOpen;
            }

            Swal.fire(swalToastConfig);
        };

        app.config.globalProperties.$foneturkConfirmation = (text, title="CONFIRMATION") => {
            let swalConfirmationConfig = {
                customClass: {
                    container:      'foneturk-confirmation-container',
                    popup:          'foneturk-confirmation-popup',
                    htmlContainer:  'foneturk-confirmation-html-container',
                    actions:        'foneturk-confirmation-actions',
                    confirmButton:  'btn-foneturk-confirmation-confirm',
                    cancelButton:   'btn-foneturk-confirmation-cancel'
                },
                showClass: {
                    popup: 'swal2-confirmation-show',
                },
                hideClass: {
                    popup: 'swal2-confirmation-hide',
                },
                toast: true,
                showConfirmButton: true,
                showCancelButton:  true,
                confirmButtonText: 'EVET',
                cancelButtonText:  'HAYIR',
                html: `
                    <div class="foneturk-confirmation">
                        <div class="foneturk-confirmation__header">
                            <span class="foneturk-confirmation-header__icon"></span>
                            <span class="foneturk-confirmation-header__text">${title}</span>
                        </div>
                        <span class="foneturk-confirmation__text">${text}</span>
                    </div>
                `,
            };

            return Swal.fire(swalConfirmationConfig);
        };

        app.config.globalProperties.$foneturkError = (options={
            title:    'HATA',
            text:     'Lorem ipsum dolor sit amet.',
            didOpen:  () => {},
            didClose: () => {},
        }) => {
            
            if(!options.title){ options.title = 'HATA'; }

            let swalErrorConfig = {
                customClass: {
                    container:     'foneturk-error-container',
                    popup:         'foneturk-error-popup',
                    htmlContainer: 'foneturk-error-html-container',
                },
                showClass: {
                    popup: 'swal2-toast-show',
                },
                hideClass: {
                    popup: 'swal2-toast-hide',
                },
                showConfirmButton: false,
                toast: true,
                timer: 1500,
                html: `
                    <div class="foneturk-error">
                        <div class="foneturk-error__header">
                            <span class="foneturk-error-header__icon"></span>
                            <span class="foneturk-error-header__text">${options.title}</span>
                        </div>
                        <span class="foneturk-error__text">${options.text}</span>
                    </div>
                `,
                willOpen: (el) => {
                    el.addEventListener("click", () => {
                        Swal.close();
                    });
                },
                didOpen: options.didOpen,
                didClose: options.didClose,
            };

            Swal.fire(swalErrorConfig);
        };
    }
}